import React, { Fragment } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

const HomeCertificates = () => (
  <StaticQuery
    query={graphql`
      query {
        eruboshiIcon: file(
          relativePath: { eq: "certifications/eruboshi-3.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        kuruminIcon: file(
          relativePath: { eq: "certifications/kurumin-5.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        nadeshikoIcon: file(
          relativePath: { eq: "certifications/nadeshiko-6.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        diversity100Icon: file(
          relativePath: { eq: "certifications/diversity_100-6.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100, maxHeight: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={(data) => (
      <Fragment>
        <div className="row mx-0 home-certificate">
          <div className="col-12 home-certificate-content">
            <div className="certificate-title">
              <span className="text-green">認定マーク</span>で企業を探す
            </div>
            <div className="row mx-0 certificates-wrapper w-100">
              <div className="certificate col-md-2 col-6 text-center">
                <Link to="/certification/eruboshi/">
                  {/* <img alt="えるぼし" srcSet={data.eruboshiIcon.childImageSharp.fixed.srcSet} /> */}
                  <Img fluid={data.eruboshiIcon.childImageSharp.fluid} />
                  <div>
                    <small>えるぼし</small>
                  </div>
                </Link>
              </div>
              <div className="certificate col-md-2 col-6 text-center">
                <Link to="/certification/kurumin/">
                  {/* <img alt="くるみん" srcSet={data.kuruminIcon.childImageSharp.fixed.srcSet} /> */}
                  <Img fluid={data.kuruminIcon.childImageSharp.fluid} />
                  <div>
                    <small>くるみん</small>
                  </div>
                </Link>
              </div>
              <div className="certificate col-md-2 col-6 text-center">
                <Link to="/certification/nadeshiko/">
                  {/* <img alt="なでしこ銘柄" srcSet={data.nadeshikoIcon.childImageSharp.fixed.srcSet} /> */}
                  <Img fluid={data.nadeshikoIcon.childImageSharp.fluid} />
                  <div>
                    <small>なでしこ銘柄</small>
                  </div>
                </Link>
              </div>
              <div className="certificate col-md-2 col-6 text-center">
                <Link to="/certification/diversity_100/">
                  {/* <img alt="ダイバーシティ100選" srcSet={data.diversity100Icon.childImageSharp.fixed.srcSet} /> */}
                  <Img fluid={data.diversity100Icon.childImageSharp.fluid} />
                  <div>
                    <small>ダイバーシティ100</small>
                  </div>
                </Link>
              </div>
              <div className="certificate col-md-2 col-6 text-center" />
              <div className="certificate col-md-2 col-6 text-center" />
            </div>
          </div>
        </div>
      </Fragment>
    )}
  />
);

export default HomeCertificates;
